import React, { useEffect, useState, useMemo }from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";

import T from '../i18n/i18n';
import { Container, Content, Button, NoMobile, NoMobileContent, NoMobileImage } from './Home.styles';
import ProfileSidebar from './ProfileSidebar/ProfileSidebar';
import Tutorial from '../Tutorial/Tutorial';
import mobileAndTabletCheck from './mobile';
import Changelog from '../Changelog/Changelog';
import PopupDonate from '../PopupDonate/PopupDonate';
import { getStatus } from '../../services/profile';
import { configActions } from '../../redux/actions';

export default ({children}) => {
    const [isMobile, setIsMobile] = useState(mobileAndTabletCheck());
    const token = useSelector(state => state.authState.token);
    const playerId = useSelector(state => state.authState.id);

    const hideTutorial = useMemo(()=>{
        return localStorage.getItem('hide-tutorial-home-'+playerId) || false;
    }, [playerId]);

    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        (async () => {
            await getStatus();
            dispatch(configActions.setTableId('0'));
        })();
    }, []);

    useEffect(() => {
        if (!token) {
            history.replace('/');
        } else {
            const redirect = localStorage.getItem('redirect');

            if (redirect) {
                console.log('deveria dar redirect para ', redirect);
                localStorage.removeItem('redirect');
                document.location = redirect;
            }
        }
    }, [token, history]);

    return <Container>
        <ProfileSidebar />
        <Content>
            { children }
        </Content>
        {hideTutorial ? null : <Tutorial start={1} end={5} id="home" />}
        <PopupDonate />
        <Changelog />
        {isMobile ? <NoMobile>
            <NoMobileImage />
            <NoMobileContent>
                <T value="profile.noMobile" />
            </NoMobileContent>
            <Button className='full' color="#f92" onClick={()=>{setIsMobile(false)}}><T value="profile.noMobileNext" /></Button>
        </NoMobile> : null}
    </Container>
};